import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { updatePurchaseOrder } from '../common/api/clients/mariapps.api';

export const useMariAppsUpdatePurchaseOrder = () => {
    return useMutation<void, AxiosError<{ error?: string }>, string>({
        mutationFn: updatePurchaseOrder,
    });
};
